"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transfersRequestSelector = exports.transfersByProductIdSelector = exports.formattedTransfersRequestSelector = void 0;
var _reselect = require("reselect");
var _get = _interopRequireDefault(require("lodash/get"));
var _productPositionSelectors = require("./productPositionSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var transfersByProductIdSelector = exports.transfersByProductIdSelector = (0, _reselect.createSelector)([function (state) {
  return state.transferRequest.items;
}, function (state) {
  return state.transferRequestRequested.items;
}, function (state) {
  return state.transfer.transfers;
}, function (state) {
  return state.transfer.transfersReceived;
}, function (state) {
  return state.apexCore.position.selectedProductId;
}], function (receivedRequests, sentRequests, sentTransfers, receivedTransfers, selectedProductId) {
  var filterFn = function filterFn(item) {
    return item.ProductId === selectedProductId;
  };
  return {
    receivedRequests: sortTransfersByDate(receivedRequests.filter(filterFn)),
    sentRequests: sortTransfersByDate(sentRequests.filter(filterFn)),
    sentTransfers: sortTransfersByTransferId(sentTransfers.filter(filterFn)),
    receivedTransfers: sortTransfersByTransferId(receivedTransfers.filter(filterFn))
  };
});
var transfersRequestSelector = exports.transfersRequestSelector = (0, _reselect.createSelector)(function (state) {
  return state.transferRequest.items;
}, function (transferRequestItems) {
  var filteredItems = Array.isArray(transferRequestItems) ? transferRequestItems.filter(function (item) {
    return item.Status === 'Requested';
  }) : [];
  return filteredItems;
});
var formattedTransfersRequestSelector = exports.formattedTransfersRequestSelector = (0, _reselect.createSelector)(transfersRequestSelector, function (state) {
  return state;
}, function (items, state) {
  return items.map(function (i) {
    var RequestorUsername = i.RequestorUsername,
      Amount = i.Amount,
      RequestCode = i.RequestCode;
    var product = (0, _productPositionSelectors.getProductByIdSelector)(state, i.ProductId);
    /**
     * Filter undefined products to prevent DOS attack [DEV-1082].
     */
    if (!product) return undefined;
    var iconFileName = product.iconFileName,
      ProductSymbol = product.ProductSymbol,
      ProductFullName = product.ProductFullName;
    return {
      id: RequestCode,
      type: 'transfer',
      RequestCode: RequestCode,
      iconFileName: iconFileName,
      ProductSymbol: ProductSymbol,
      ProductFullName: ProductFullName,
      RequestorUsername: RequestorUsername,
      Amount: Amount
    };
  }).filter(function (i) {
    return i;
  });
});
var sortTransfersByTransferId = function sortTransfersByTransferId(transfers) {
  return transfers.sort(function (a, b) {
    var firstTransferId = (0, _get["default"])(a, 'TransferId');
    var secondTransferId = (0, _get["default"])(b, 'TransferId');
    if (firstTransferId > secondTransferId) {
      return -1;
    } else if (firstTransferId < secondTransferId) {
      return 1;
    } else {
      return 0;
    }
  });
};
var sortTransfersByDate = function sortTransfersByDate(transfers) {
  return transfers.sort(function (a, b) {
    var firstTimestamp = (0, _get["default"])(a, 'CreatedTimestamp');
    var secondTimestamp = (0, _get["default"])(b, 'CreatedTimestamp');
    if (firstTimestamp > secondTimestamp) {
      return -1;
    } else if (firstTimestamp < secondTimestamp) {
      return 1;
    } else {
      return 0;
    }
  });
};